import { createContext } from "react";

const LogedIn = createContext()

export default LogedIn;